import TextInput from "common/blocks/TextInput";
import {
    FieldErrors,
    FieldValues,
    RegisterOptions,
    UseFormRegister,
    UseFormSetValue,
    UseFormWatch,
} from "react-hook-form";
import { PartExchangeQuestions } from "services/motorpoint/partExchangeQuestions";

const dataEntryQuestionViewModelHelper = ({
    questionTextClassName,
    optionsClassName,
    questionClassName,
    errors,
    model,
    options,
    defaultValue,
    register,
    watch,
    setValue,
}: {
    questionClassName: string;
    questionTextClassName: string;
    optionsClassName: string;
    options?: RegisterOptions<FieldValues, string> | undefined;
    errors: FieldErrors<FieldValues>;
    model: PartExchangeQuestions.PartExchangeQuestionViewModel;
    defaultValue: string | undefined;
    register: UseFormRegister<FieldValues>;
    watch: UseFormWatch<FieldValues>;
    setValue: UseFormSetValue<FieldValues>;
}): JSX.Element => {
    const financeAmountText = model.Title;
    const identifier = model.Identifier;
    const value = watch(identifier, defaultValue);
    const message = model.AttributesDictionary?.["data-validation-message"] ?? "";

    return (
        <div key={identifier} className={questionClassName}>
            <span className={questionTextClassName}>{financeAmountText}</span>
            <div className={optionsClassName}>
                <TextInput
                    {...register(identifier, {
                        ...options,
                        onChange: (event) => {
                            if (event.target.value < 0) {
                                setValue(identifier, "0");
                            }
                        },
                    })}
                    type="number"
                    value={value}
                    hasError={!!errors[identifier]?.message}
                    errorText={message}
                />
            </div>
        </div>
    );
};

export default dataEntryQuestionViewModelHelper;
